import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinpimprichichwad() {



const cardData = {
  keyword: " Cab Service in Pimpri Chinchwad   ",

"headingDescription": "SRS Cab Service offers Cab Service in Pimpri Chinchwad, providing reliable, comfortable, and safe transportation for daily commuting, business trips, airport transfers, and leisure travel. Our well-maintained vehicles, professional drivers, and punctual service ensure a smooth and hassle-free journey across Pimpri Chinchwad and nearby areas. With flexible booking options, transparent pricing, and 24/7 customer support, SRS Cab Service is your trusted partner for convenient and enjoyable travel.",
"topPlaces": [
  {
    "title": "Akkalkot Swami Samarth Mandir",
    "description": "Akkalkot Swami Samarth Mandir is a spiritual site attracting devotees from across the region. Travelers using Cab Service in Pimpri Chinchwad from SRS Cab Service often visit for blessings and cultural experiences."
  },
  {
    "title": "Chinchwad Ganpati Temple",
    "description": "Chinchwad Ganpati Temple is a prominent religious site in the area. Visitors using SRS Cab Service frequently stop here to participate in local traditions and seek spiritual solace."
  },
  {
    "title": "Pimpri Chinchwad Science Park",
    "description": "Pimpri Chinchwad Science Park is a family-friendly educational destination. Travelers using SRS Cab Service often include this spot for learning and recreational visits."
  },
  {
    "title": "Sinhgad Institute of Technology",
    "description": "Sinhgad Institute of Technology is an important educational landmark. Visitors using SRS Cab Service often explore the surrounding campus and nearby attractions."
  },
  {
    "title": "Appu Ghar Amusement Park",
    "description": "Appu Ghar Amusement Park offers entertainment and fun rides for families and children. Travelers using SRS Cab Service often plan visits for leisure and recreation."
  },
  {
    "title": "Kasarwadi Market",
    "description": "Kasarwadi Market is a bustling shopping area in Pimpri Chinchwad. Visitors using SRS Cab Service often explore local shops and eateries here."
  },
  {
    "title": "Rahate Colony Park",
    "description": "Rahate Colony Park is a peaceful green space ideal for walking and relaxation. Travelers using SRS Cab Service often include this spot for outdoor leisure."
  },
  {
    "title": "PCMC Stadium",
    "description": "PCMC Stadium hosts sports events and recreational activities. Visitors using SRS Cab Service often attend matches or engage in outdoor exercises."
  },
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "Rajiv Gandhi Infotech Park is a major IT hub in Pimpri Chinchwad. Business travelers using SRS Cab Service frequently visit this area for professional engagements."
  },
  {
    "title": "Pimpri Chinchwad Cultural Center",
    "description": "This cultural center hosts events, performances, and exhibitions. Travelers using SRS Cab Service often attend shows to experience local art and culture."
  }
],



services: [
{
name: "Cab Service in Pimpri Chinchwad",
description: "Cab service in Pimpri Chinchwad offers reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pimpri Chinchwad Cab Service",
description: "Pimpri Chinchwad cab service provides dependable travel for city and intercity routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Pimpri Chinchwad",
description: "Taxi service in Pimpri Chinchwad offers convenient transportation for daily and outstation travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pimpri Chinchwad Taxi Service",
description: "Pimpri Chinchwad taxi service provides reliable transportation for local and long-distance travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Pimpri Chinchwad",
description: "Cab booking Pimpri Chinchwad offers quick and easy reservation options for customers. Users can book rides anytime for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Taxi Booking Pimpri Chinchwad",
description: "Taxi booking Pimpri Chinchwad provides convenient online and offline booking services. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Cab Near Pimpri Chinchwad",
description: "Cab near Pimpri Chinchwad helps customers find nearby taxis quickly. Users can book cabs instantly for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with nearby cab services."
},
{
name: "Taxi Near Pimpri Chinchwad",
description: "Taxi near Pimpri Chinchwad offers quick access to local and airport travel options. Customers can book taxis instantly for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Best Cab Service in Pimpri Chinchwad",
description: "Best cab service in Pimpri Chinchwad offers top-rated transportation for customers. Users can enjoy reliable and comfortable travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Cheap Cab Service Pimpri Chinchwad",
description: "Cheap cab service Pimpri Chinchwad provides affordable travel options for customers. Users can book budget-friendly rides for local and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Affordable Cab Service Pimpri Chinchwad",
description: "Affordable cab service Pimpri Chinchwad offers cost-effective travel solutions for customers. Users can book economical rides for daily and intercity travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pimpri Chinchwad Cab Hire",
description: "Pimpri Chinchwad cab hire provides flexible rental options for local and outstation travel. Customers can book cabs for hourly and daily use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Pimpri Chinchwad Taxi Hire",
description: "Pimpri Chinchwad taxi hire offers convenient rental services for customers. Users can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Local Cab Service Pimpri Chinchwad",
description: "Local cab service Pimpri Chinchwad provides reliable transportation for city travel. Customers can book cabs for daily commuting needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with local cab services."
},
{
name: "Pimpri Chinchwad Cab for Airport",
description: "Pimpri Chinchwad cab for airport offers reliable transfer for passengers. Customers can book cabs for timely airport drop and pickup. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pimpri Chinchwad Airport Cab Service",
description: "Pimpri Chinchwad airport cab service provides convenient airport transfer solutions. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pimpri Chinchwad Cab for Outstation",
description: "Pimpri Chinchwad cab for outstation offers reliable travel for long-distance trips. Customers can book cabs for tours and business journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Cab Service Pimpri Chinchwad Pune",
description: "Cab service Pimpri Chinchwad Pune provides dependable transportation for city and intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Pimpri Chinchwad Pune",
description: "Taxi service Pimpri Chinchwad Pune offers reliable transportation for local and airport travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Pimpri Chinchwad Pune",
description: "Cab booking Pimpri Chinchwad Pune provides easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Innova Cab Pimpri Chinchwad",
description: "Innova cab Pimpri Chinchwad offers spacious SUV travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for long-distance travel. Travel easily with Innova cab services."
},
{
name: "Innova Crysta Cab Pimpri Chinchwad",
description: "Innova Crysta cab Pimpri Chinchwad provides premium SUV travel for comfort and luxury. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab Pimpri Chinchwad",
description: "Ertiga cab Pimpri Chinchwad offers comfortable 7 seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
}
],

tableData: [
["Cab Service in Pimpri Chinchwad","Pimpri Chinchwad Cab Service"],
["Taxi Service in Pimpri Chinchwad","Pimpri Chinchwad Taxi Service"],
["Cab Booking Pimpri Chinchwad","Taxi Booking Pimpri Chinchwad"],
["Cab Near Pimpri Chinchwad","Taxi Near Pimpri Chinchwad"],
["Best Cab Service in Pimpri Chinchwad","Cheap Cab Service Pimpri Chinchwad"],
["Affordable Cab Service Pimpri Chinchwad","Pimpri Chinchwad Cab Hire"],
["Pimpri Chinchwad Taxi Hire","Local Cab Service Pimpri Chinchwad"],
["Pimpri Chinchwad Cab for Airport","Pimpri Chinchwad Airport Cab Service"],
["Pimpri Chinchwad Cab for Outstation","Cab Service Pimpri Chinchwad Pune"],
["Taxi Service Pimpri Chinchwad Pune","Cab Booking Pimpri Chinchwad Pune"],
["Innova Cab Pimpri Chinchwad","Innova Crysta Cab Pimpri Chinchwad"],
["Ertiga Cab Pimpri Chinchwad","Cab Service Pimpri Chinchwad"]
],



whychoose: [
  {
    WhyChooseheading: "Wide Coverage Across Pimpri Chinchwad",
    WhyChoosedescription: "SRS Cab Service provides reliable cab service across Pimpri, Chinchwad, Wakad, Nigdi, Bhosari, Akurdi, and all major areas of PCMC."
  },
  {
    WhyChooseheading: "Affordable Cab Service in PCMC",
    WhyChoosedescription: "We offer budget-friendly cab services in Pimpri Chinchwad with transparent pricing. Customers receive clear fare details with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for local travel, airport transfers, and outstation cab bookings from Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles ensuring a smooth and comfortable ride across Pune and PCMC."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses."
  },
  {
    WhyChooseheading: "Fast Pickup & Doorstep Service",
    WhyChoosedescription: "We provide quick pickup from homes, offices, industries, and residential societies across Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Safe & Professional Drivers",
    WhyChoosedescription: "Our trained drivers ensure safe driving, polite behavior, and a reliable travel experience for every ride."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Pimpri Chinchwad",
    WhyChoosedescription: "SRS Cab Service is trusted by residents and businesses in PCMC for punctual service, affordable pricing, and customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide cab service in Pimpri Chinchwad?", answer: "Yes, SRS Cab Service offers reliable cab services in Pimpri Chinchwad for local and outstation travel." },
  { question: "Is cab service available 24 hours in PCMC?", answer: "Yes, our cab service operates 24/7 for all travel needs." },
  { question: "Do you provide airport cab service from Pimpri Chinchwad?", answer: "Yes, we provide Pune Airport pickup and drop services from PCMC areas." },
  { question: "Which areas do you cover in PCMC?", answer: "We cover Pimpri, Chinchwad, Wakad, Nigdi, Bhosari, Akurdi, Moshi, and nearby areas." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book cab online?", answer: "Yes, you can easily book cab service online or via phone." },
  { question: "Do you provide one-way and outstation cab?", answer: "Yes, we provide one-way and outstation cab services from Pimpri Chinchwad." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, experienced, and verified." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Patil",
    feedback:
      "Booked cab from Pimpri to airport. Very quick service and smooth ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Sharma",
    feedback:
      "Best cab service in Pimpri Chinchwad. Clean car, on-time pickup, and professional driver.",
    rating: 5
  }
];





















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pimpri Chinchwad Cab Service | SRS Cab Service",
  "description": "Book reliable and affordable cabs in Pimpri Chinchwad, Pune. Offering one-way and round-trip taxi services, local rides, and airport transfers with Innova, Ertiga, and Sedan cabs. Available 24/7 for corporate and personal travel.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pimpri Chinchwad",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411018",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.6298",
    "longitude": "73.7997"
  },
  "url": "https://www.srscabservice.com/pimpri-chinchwad-cab-service",
  "areaServed": [
    "Pimpri", "Chinchwad", "Nigdi", "Bhosari", "Akurdi", "Pimpri Chinchwad Industrial Area"
  ],
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceType": [
    "Pimpri Chinchwad Cab Service",
    "Local and Outstation Cabs",
    "Airport Transfer",
    "Innova, Ertiga, Sedan cab hire"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "650"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pimpri Chinchwad Cab Service | SRS Cab Service</title>
  <meta 
    name="description" 
    content="Book reliable cabs in Pimpri Chinchwad, Pune. Affordable Innova, Ertiga, and Sedan cabs for local rides, airport transfers, and outstation trips. Available 24/7 for corporate and personal travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinpimprichichwad;